import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["questions", "address", "requiresShippingAddress"],
    _excluded2 = ["__typename"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { useFocusErrors } from '@infl-ts/util-react-hook-form';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, Slide, styled, Typography } from '@mui/material';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { constNull, flow, pipe } from 'fp-ts/function';
import * as Id from 'fp-ts/Identity';
import * as NEA from 'fp-ts/NonEmptyArray';
import * as O from 'fp-ts/Option';
import { forwardRef, useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { createDefaultShippingAddress, formatShippingAddressResponse, ShippingAddressInputs } from '../edit-profile';
import { extractAndFormatQuestions, formatQuestionDefaults, QuestionInputs } from '../form';
import { shippingUpdateFailure } from './alerts';
import { useUpdateShippingAddress } from './mutations';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Transition = /*#__PURE__*/forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_jsx(Slide, _objectSpread({
    direction: "up",
    ref: ref
  }, props));
});

var getDefaultStructure = function getDefaultStructure(questions, address) {
  return _objectSpread(_objectSpread({}, questions ? formatQuestionDefaults(questions) : null), {}, {
    shippingAddress: pipe(address, O.fromNullable, O.match(function () {
      return createDefaultShippingAddress('');
    }, function (shipAddress) {
      return _objectSpread(_objectSpread({}, shipAddress), {}, {
        address2: shipAddress.address2 || ''
      });
    }))
  });
};

var ContentWrapper = styled(DialogContent)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiBox-root:last-child {\n    margin-bottom: 0;\n  }\n"])));

var PureRedeemDialog = function PureRedeemDialog(_ref) {
  var title = _ref.title,
      handleRedeem = _ref.handleRedeem,
      questions = _ref.questions,
      onClose = _ref.onClose,
      points = _ref.points,
      open = _ref.open,
      redeemText = _ref.redeemText,
      perksCount = _ref.perksCount,
      requiresShippingAddress = _ref.requiresShippingAddress,
      questionForm = _ref.questionForm,
      _ref$saveShippingInfo = _slicedToArray(_ref.saveShippingInfo, 2),
      saveShipping = _ref$saveShippingInfo[0],
      setSaveShipping = _ref$saveShippingInfo[1],
      updateAddress = _ref.updateAddress,
      currentPoints = _ref.currentPoints,
      questionRef = _ref.questionRef,
      focusOnFirstError = _ref.focusOnFirstError,
      t = _ref.t;

  return /*#__PURE__*/_jsxs(Dialog, {
    PaperProps: {
      sx: {
        width: 1,
        maxWidth: 520
      }
    },
    TransitionComponent: Transition,
    open: open,
    onClose: onClose,
    "aria-labelledby": "redeem-reward",
    "data-element": "Dialog",
    "data-component": "PureRedeemDialog",
    "data-source-file": "redeem-dialog.tsx",
    children: [/*#__PURE__*/_jsx(DialogTitle, {
      sx: {
        fontSize: function fontSize(t) {
          return t.typography.h2.fontSize;
        }
      },
      "data-element": "DialogTitle",
      "data-component": "PureRedeemDialog",
      "data-source-file": "redeem-dialog.tsx",
      children: t("You're redeeming \"{{title}}\"", {
        title: title
      })
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      dividers: true,
      "data-element": "ContentWrapper",
      "data-source-file": "redeem-dialog.tsx",
      children: [/*#__PURE__*/_jsx(DialogContentText, {
        sx: {
          mb: 3
        },
        "data-element": "DialogContentText",
        "data-source-file": "redeem-dialog.tsx",
        children: perksCount > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [t('This reward is free'), '. ', /*#__PURE__*/_jsx(Trans, {
            values: {
              points: currentPoints.toLocaleString()
            },
            components: {
              1: /*#__PURE__*/_jsx(Typography, {
                sx: {
                  fontWeight: 'bold'
                },
                component: "span"
              })
            },
            children: "You will have <1>{{points}} points</1> afterwards"
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Trans, {
            values: {
              points: points.toLocaleString()
            },
            components: {
              1: /*#__PURE__*/_jsx(Typography, {
                sx: {
                  fontWeight: 'bold'
                },
                component: "span"
              })
            },
            children: "This will cost you <1>{{points}} points</1>"
          }), '. ', /*#__PURE__*/_jsxs(Trans, {
            values: {
              points: (currentPoints - points).toLocaleString()
            },
            components: {
              1: /*#__PURE__*/_jsx(Typography, {
                sx: {
                  fontWeight: 'bold'
                },
                component: "span"
              })
            },
            children: ["You will have <1>{{points}} points</1> afterwards", "."]
          })]
        })
      }), questions && A.isNonEmpty(questions) ? /*#__PURE__*/_jsx(QuestionInputs, {
        questions: questions // @ts-expect-error - `T` type should be assignable to the base type
        //  `Record<string, ResponseFormType>` here. However, the `T` type is
        //  being used both covariantly and contravariantly in `UseFormReturn`
        //  type, thus making it invariant and thus causing an error here.
        ,
        questionForm: questionForm,
        questionRef: questionRef
      }) : null, requiresShippingAddress && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Divider, {
          sx: {
            mt: 3
          }
        }), /*#__PURE__*/_jsx(DialogContentText, {
          sx: {
            mt: 2,
            mb: 3
          },
          children: t('Shipping Information')
        }), /*#__PURE__*/_jsx(ShippingAddressInputs, {
          shippingAddressForm: questionForm,
          verticalSpacing: 2
        }), /*#__PURE__*/_jsx(FormControlLabel, {
          control: /*#__PURE__*/_jsx(Checkbox, {
            checked: saveShipping,
            onChange: function onChange() {
              return setSaveShipping(!saveShipping);
            }
          }),
          label: t('Update address in your Profile')
        })]
      })]
    }), /*#__PURE__*/_jsxs(DialogActions, {
      "data-element": "DialogActions",
      "data-source-file": "redeem-dialog.tsx",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        "data-element": "Button",
        "data-source-file": "redeem-dialog.tsx",
        children: t('Cancel')
      }), /*#__PURE__*/_jsx(Button, {
        variant: "contained",
        onClick: questionForm.handleSubmit(function (data) {
          return pipe({
            responses: questions && A.isNonEmpty(questions) ? extractAndFormatQuestions(Object.entries(data), pipe(questions, NEA.groupBy(function (q) {
              return q.id;
            }))) : undefined,
            shippingAddress: requiresShippingAddress ? formatShippingAddressResponse(data.shippingAddress) : undefined
          }, Id.chainFirst(handleRedeem), function (_ref2) {
            var shippingAddress = _ref2.shippingAddress;
            if (saveShipping && shippingAddress !== undefined) void updateAddress({
              variables: {
                input: shippingAddress
              }
            });
            shippingAddress ? questionForm.reset({
              shippingAddress: shippingAddress
            }) : questionForm.reset();
          });
        }, focusOnFirstError),
        "data-element": "Button",
        "data-source-file": "redeem-dialog.tsx",
        children: t(redeemText)
      })]
    })]
  });
};

var useProps = function useProps(_ref3) {
  var questions = _ref3.questions,
      address = _ref3.address,
      requiresShippingAddress = _ref3.requiresShippingAddress,
      props = _objectWithoutProperties(_ref3, _excluded);

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var defaultShippingAddress = pipe(address, O.fromNullable, O.match(constNull, function (_ref4) {
    var __typename = _ref4.__typename,
        shippingAddress = _objectWithoutProperties(_ref4, _excluded2);

    return shippingAddress;
  }));

  var _useUpdateShippingAdd = useUpdateShippingAddress({
    onCompleted: E.match(function () {
      return showAlert(shippingUpdateFailure(t));
    }, function (_ref5) {
      var editShippingAddress = _ref5.editShippingAddress;
      return editShippingAddress.__typename === 'EditShippingAddressErrors' && showAlert(shippingUpdateFailure(t));
    })
  }),
      _useUpdateShippingAdd2 = _slicedToArray(_useUpdateShippingAdd, 1),
      updateAddress = _useUpdateShippingAdd2[0];

  var _useFocusErrors = useFocusErrors(),
      questionRef = _useFocusErrors.questionRef,
      focusOnFirstError = _useFocusErrors.focusOnFirstError;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return _objectSpread(_objectSpread({}, props), {}, {
    questions: questions,
    saveShippingInfo: useState(false),
    requiresShippingAddress: requiresShippingAddress,
    questionForm: useForm({
      defaultValues: getDefaultStructure(questions, defaultShippingAddress)
    }),
    updateAddress: updateAddress,
    questionRef: questionRef,
    focusOnFirstError: focusOnFirstError,
    t: t
  });
};

export default Object.assign(flow(useProps, PureRedeemDialog), {
  displayName: 'RedeemDialog'
});